import { Box, Typography } from '@material-ui/core';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import { ContactMeForm } from 'components/shared/contact-me-form';
import { FreeTrialDialog } from 'components/shared/free-trial-dialog';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { GetUrlBuilderData } from 'store/url-builder';
import hoverStyle from 'styles/hover-overlay.module.scss';
import { ContactMeDialog } from './contact-me-dialog';

export interface ContactMeProps {
    builderType: string;
    isFree?: boolean | null;
}

export const ContactMe = ({ builderType, isFree = null }: ContactMeProps) => {
    const urlBuilder = useSelector(GetUrlBuilderData);
    const [contactMeDialog, setContactMeDialog] = useState(false);
    const [freeTrialDialog, setFreeTrialDialog] = useState(false);
    const handleClose = () => setContactMeDialog(false);
    const openFreeTrialDialog = () => setFreeTrialDialog(true);
    const handleCloseFreeTrialDialog = () => setFreeTrialDialog(false);
    return (
        <Box className={hoverStyle.root}>
            <ContactMeForm color={urlBuilder.primaryColor.color} fileds={urlBuilder.contactForm.fields} userId={urlBuilder.userId} />
            <Box onClick={!isFree ? () => setContactMeDialog(true) : openFreeTrialDialog} className={hoverStyle.root_content}>
                <Typography variant='subtitle2' className='d-flex aling-items_center' color='textSecondary'>
                    <EditOutlinedIcon fontSize='small' /> <b>Edit Contact Information</b>
                </Typography>
            </Box>
            {contactMeDialog && <ContactMeDialog isOpen={contactMeDialog} onClose={handleClose} builderType={builderType} />}
            {freeTrialDialog && <FreeTrialDialog isOpen={freeTrialDialog} onClose={handleCloseFreeTrialDialog} />}
        </Box>
    );
};
